/**
 * Absolutely Access Control Utility
 *
 * Handles access control for Absolutely feature pages.
 * Users must have access to the page with accessControl.itemId "700" from the allpage API.
 */

/**
 * Access Item ID required for Absolutely feature
 */
export const ABSOLUTELY_ACCESS_ITEM_ID = '700';

/**
 * Check if user has Absolutely access (accessControl.itemId "700")
 * Checks the allpage/all-page-icons API response for an item with accessControl.itemId === "700"
 *
 * @param {Object} store - Vuex store instance
 * @returns {boolean} True if user has access, false otherwise
 */
export function hasAbsolutelyAccess(store) {
  // Check if store exists
  if (!store || !store.state || !store.state.allpage) {
    return false;
  }

  const allPageIcons = store.state.allpage.allPageIcons;

  // Check if allPageIcons array exists and is an array
  if (!Array.isArray(allPageIcons) || allPageIcons.length === 0) {
    return false;
  }

  // Find the page icon with accessControl.itemId === "700"
  const absolutelyPage = allPageIcons.find(
    icon => icon.accessControl?.itemId === ABSOLUTELY_ACCESS_ITEM_ID,
  );

  // If the page exists in the response, user has access
  // The API already filters based on user's access rights
  return !!absolutelyPage;
}
